import React, { useState} from "react";
import { useParams } from "react-router-dom";
import { PageTopbar } from "../../components/Page/Topbar";
import { PageHeader } from "../../components/Page/Header";
import { AppOrdersDetails } from "../../app/Orders/Details";


export function RoutesOrdersDetails({ parents, current }) {

    const { orderId } = useParams();
    const [ title, setTitle] = useState(null);

    return (
        <div>
            <PageTopbar
                parents={parents}
                current={current}
            />

            {/* <Identity /> */}

            <PageHeader
                title={title}
                parents={parents}
                current={current}
                tabGroup={"orders-details"}
                variables={{orderId: orderId}}
            />

             <AppOrdersDetails
                orderId={orderId}
                setTitle={setTitle}
            />
        </div>
    );
}